import { Injectable } from '@angular/core';
import { HttpDataService } from '../../../../shared/http/http-data.service';
import { ICompany, ICurrency, IDescribedNamedRecord, ILov } from '../../../../../type_definitions/datatypes';


export interface IOrderableItemCategory {
  name?:string;
  description?:string;
  sequence?:number;
}

export interface IOrderableItem {
  id?:number;
  category?:IOrderableItemCategory;
  creationDate?:number;
  description?:string;
  extraFixACSL?:number;
  extraFixBP?:number;
  extraFixLAM?:number;
  globalItemId?:number;
  modificationDate?:number;
  oem?:ICompany;
  part?:string;
  globalPart?:string;
  shortDescription?:string;
  standardProductValue?:boolean;
  type?:ILov;
  unit?:ILov;
  price?:number;
  comments?:string;
  fixedUnitType?:boolean;
  globalItemPrice?:string;
}

export interface IOrderableItemResponse {
  currency?:ICurrency;
  items:IOrderableItem[];
}

export enum ServiceCatalogType {
  FIXED = 'FIXED',
  QUOTEABLE = 'QUOTEABLE',
  NOT_AVAILABLE = 'NA'
}

interface IPreselectionOption {
  label:string;
  value:boolean;
}

export const CATALOG_ACTION_TYPE_NEW:string = 'NEW';

@Injectable()
export class BPProfilesCatalogDataService {
  constructor(
    private httpDataService:HttpDataService
  ) {
    /**/
  }

  public getPreselectionOptions():IPreselectionOption[] {
    return [
      { value: true, label: 'BPPROFILES.CATALOG.PRESELECTION_OK' },
      { value: false, label: 'BPPROFILES.CATALOG.PRESELECTION_OTHER' }
    ];
  }

  public getPossibleCategories():IOrderableItemCategory[] {
    return [
      {
        name: 'ENGINEERS',
        description: 'ENGINEERS'
      },
      {
        name: 'SERVICES',
        description: 'SERVICES'
      }
    ];
  }

  public getCatalogItems(profileId:number):Promise<IOrderableItemResponse> {
    return this.httpDataService.doGET(
      `rest/bpprofiles/profiles/${profileId}/catalog/orderableitems`,
      undefined,
      undefined,
      'Error loading catalog items'
    );
  }

  public addCatalogItem(profileId:number, model:IOrderableItem):Promise<IOrderableItem> {
    return this.httpDataService.doPOST(
      `rest/bpprofiles/profiles/${profileId}/catalog`,
      undefined,
      model,
      undefined,
      'Error adding catalog item'
    );
  }

  public updateCatalogItem(profileId:number, model:IOrderableItem):Promise<IOrderableItem> {
    return this.httpDataService.doPUT(
      `rest/bpprofiles/profiles/${profileId}/catalog/${model.id}`,
      undefined,
      model,
      undefined,
      'Error updating catalog item'
    );
  }

  public deleteCatalogItem(profileId:number, itemId:number):Promise<void> {
    return this.httpDataService.doDELETE(
      `rest/bpprofiles/profiles/${profileId}/catalog/${itemId}`,
      undefined,
      undefined,
      'Error deleting catalog item'
    );
  }

  public getCatalogOEMs(profileId:number):Promise<ICompany[]> {
    return this.httpDataService.doGET(
      `rest/bpprofiles/profiles/${profileId}/catalog/oems`,
      undefined,
      undefined,
      'Error loading catalog OEMs'
    );
  }

  public getCatalogUnits(category?:string):Promise<IDescribedNamedRecord[]> {
    return this.httpDataService.doGET(
      `rest/bpprofiles/catalog/units/${category}`,
      undefined,
      undefined,
      'Error loading catalog units'
    );
  }

  public getPreselectedItems(profileId:number, category:string, oemId:number):Promise<IOrderableItemResponse> {
    return this.httpDataService.doGET(
      `rest/bpprofiles/profiles/${profileId}/catalog/orderableitems/${category}/${oemId}`,
      undefined,
      undefined,
      'Error loading preselected items'
    );
  }
}